const initialState = {
  payments: [],
  income: [],
  abc: []
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_PAYMENTS':
      return {
        ...state,
        payments: action.payments
      }
    case 'FETCH_INCOME':
      return {
        ...state,
        income: action.payload
      }
    case 'FETCH_ABC':
      return {
        ...state,
        abc: action.payload
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/reports.js